import useMenu from './use-menu';

export {useMenu};

export default useMenu;
